export const fetchArticleData = async (articleId) => {
  try {
    const response = await fetch(`/api/articles/${articleId}`)

    if (!response.ok) {
      throw new Error(`Failed to fetch article ${articleId}: ${response.statusText}`)
    }
    const data = await response.json()
    return data.article
  } catch (error) {
    console.error(`Error fetching article ${articleId}:`, error)
    return null
  }
}
